var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor-wrapper"},[_c('tiptap-vuetify',{attrs:{"extensions":_vm.extensions},model:{value:(_vm.computedContent),callback:function ($$v) {_vm.computedContent=$$v},expression:"computedContent"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }